import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { registerLicense } from '@syncfusion/ej2-base';
import { Constants } from './app/core/config/constants';
import { NGXLogger } from 'ngx-logger';
export let logger: NGXLogger;

// Registering Syncfusion license key
registerLicense(Constants.SYNCFUSION_LICENSE);

if (environment.production) {
    enableProdMode();
}

// platformBrowserDynamic()
//     .bootstrapModule(AppModule)
//     .catch((err) => console.error(err));
platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .then(() => {
        if ('serviceWorker' in navigator && environment.production) {
            navigator.serviceWorker.register('ngsw-worker.js');
        }
    })
    .catch((err) => logger.error(err));
